import { render, staticRenderFns } from "./SocialShare.vue?vue&type=template&id=a553b8a4&scoped=true&"
import script from "./SocialShare.vue?vue&type=script&lang=js&"
export * from "./SocialShare.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./SocialShare.vue?vue&type=style&index=0&id=a553b8a4&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "a553b8a4",
  "c7505654"
  
)

export default component.exports